import { IProduction } from "../types/applicationContextTypes";
import {
  AddCommissionPoliciesCases,
  AddCommissionProduction,
  AddPremiumProduction,
  AddPremiumPoliciesCases,
} from "../../redux/ProductionReducer/ProductionReducer";

const addProvidedProductionDataHelper = (productionData: IProduction[]) => {
  productionData.forEach((entry) => {
    switch (entry.qualifyingMethodId) {
      case 1:
        if (
          entry.unlimited.coverageAmount > 0 ||
          entry.limited.coverageAmount > 0
        ) {
          AddCommissionProduction({
            riskProtectionProduction: entry.unlimited.coverageAmount,
            otherNewBusiness: entry.limited.coverageAmount,
            shared: entry.isShared,
            companyProvided: !entry.productionId,
            productionId: entry.productionId,
          });
        }
        if (
          entry.unlimited.livesCovered > 0 ||
          entry.limited.livesCovered > 0
        ) {
          AddCommissionPoliciesCases({
            riskProtectionProduction: entry.unlimited.livesCovered,
            otherNewBusiness: entry.limited.livesCovered,
            shared: entry.isShared,
            companyProvided: !entry.productionId,
            productionId: entry.productionId,
          });
        }
        break;

      case 2:
        if (
          entry.unlimited.coverageAmount > 0 ||
          entry.limited.coverageAmount > 0
        ) {
          AddPremiumProduction({
            riskProtectionProduction: entry.unlimited.coverageAmount,
            otherNewBusiness: entry.limited.coverageAmount,
            shared: entry.isShared,
            companyProvided: !entry.productionId,
            productionId: entry.productionId,
          });
        }
        if (
          entry.unlimited.livesCovered > 0 ||
          entry.limited.livesCovered > 0
        ) {
          AddPremiumPoliciesCases({
            riskProtectionProduction: entry.unlimited.livesCovered,
            otherNewBusiness: entry.limited.livesCovered,
            shared: entry.isShared,
            companyProvided: !entry.productionId,
            productionId: entry.productionId,
          });
        }
        break;

      default:
        break;
    }
  });
};

export default addProvidedProductionDataHelper;
